import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";

// Schema
export const hobbySchema = itemSchema.extend({
  name: z.string().min(1),
  icon: z.string().default("hobby-book"), // Default icon class
  description: z.string().optional(),
});

// Type
export type Hobby = z.infer<typeof hobbySchema>;

// Defaults
export const defaultHobby: Hobby = {
  ...defaultItem,
  name: "",
  icon: "Reading",
  description: "",
};
